import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import CvMultiStepProgress from '../pages/app/cv/CvMultiStepProgress';

function CvPageLayout({ children, currentStep }) {
  return (
    <Container className='mb-5'>
      <h1 className="mb-4 fw-bold text-center">{currentStep}</h1>
      <hr />
      <Row>
        {/* Lewa kolumna z multistep */}
        <Col md={3} className="mx-auto p-4 rounded d-none d-md-block">
          <CvMultiStepProgress currentStep={currentStep} />
        </Col>

        {/* Prawa kolumna z treścią strony */}
        <Col md={8} className="mx-auto p-3 rounded position-relative">
          {children}
        </Col>

        <Col md={1} className="d-none d-md-block" />
      </Row>
    </Container>
  );
}

export default CvPageLayout;
